/**
 * Created by Administrator on 2017/12/7.
 */

import leftNavBar from "./left-navbar";
import uploadFile from "./upload-file";
import header from "./header";
import formHandle from "./form-handle.vue";
import formDetail from "./form-detail.vue";
import severDetail from "./sever-detail.vue";
import visitorRegisterDetail from "./visitor-register-detail";
import switchCompany from './switch-company';

import notificationDetails from "./notification-details";
import preventPlagueAdd from "./防疫/prevent-plague-add";
import preventPlagueDetails from "./防疫/prevent-plague-details";
import reworkDetails from "./防疫/rework-details";
import quarantineRegisterAdd from "./防疫/quarantine-register-add";
import approval from "./防疫/approval.vue";
import batchImport from "./防疫/batch-import";
import addRegister from './防疫/add-register.vue'
import fileDetails from "./file-details";
import meterBatchImport from "./meter-batch-import";
import evaluationResult from "./evaluationResult";

import siteDetails from "./site-details";
import contractDetails from "./contract-details";
import billDetails from "./bill-details";
import lookBill from "./look-bill";
import electronicContract from "./electronic-contract";
import createInvoice from "./create-invoice";
import billExamineDetails from "./bill-examine-details";
import billOrderInfo from "./bill-order-info";
import parkingRentalApplication from "./parking-rental-application";
import cardNumber from "./card-number.vue";
import parkingRentalDetails from "./parking-rental-details";
import addRemindStaff from "./add-remind-staff";
import companyBusinessInfo from "./company-business-info"
import checkChangeRecords from "./checkChangeRecords"
import formInput from "./form-input"
import tableInput from "./table-input"
import fileUpload from "./file-upload"


//考勤
// import attendanceSetting from './考勤/attendanceSetting'

export default {
  leftNavBar, uploadFile, header, formHandle, formDetail, severDetail, visitorRegisterDetail, notificationDetails, preventPlagueAdd, preventPlagueDetails, reworkDetails, quarantineRegisterAdd, approval, batchImport, addRegister, fileDetails,
  meterBatchImport, evaluationResult, siteDetails, contractDetails, billDetails, lookBill, electronicContract,
  createInvoice, billExamineDetails, billOrderInfo, switchCompany, parkingRentalApplication, cardNumber, parkingRentalDetails, 
  addRemindStaff, companyBusinessInfo, checkChangeRecords, formInput, tableInput, fileUpload
};



// WEBPACK FOOTER //
// ./src/components/index.js